"use client";

import { Button } from "@radix-ui/themes";
import { useState } from "react";
import RequestTNDialog from "@/components/RequestTNDialog";
import useTNStore from "@/stores/TNStore";
import { formatTNWithHiphens } from "@/utils/general";

export default function DisplayMyTN() {
    const { tn } = useTNStore();
    const [open, setOpen] = useState<boolean>(false);
    return !tn ? (
        ""
    ) : (
        <>
            <Button variant="ghost" color="gray" className="text-inherit text-5xl font-bold cursor-text justify-between" onClick={() => setOpen(true)}>
                {formatTNWithHiphens(tn)}
            </Button>
            <RequestTNDialog open={open} setOpen={setOpen} />
        </>
    );
}
